<template>
<div>
  <div class="contenedor_tabla-titulo"  id="cuandocompiten">
    <img src="@/assets/logo_teamchile.png" class="img_logo_medallero" />  <h4>Cuándo Compiten</h4>
  </div>
  <table cellpadding="0" cellspacing="0"  class="table table table-striped tabla_resultados">
    <thead>
      <tr class="tabla_info_calendario">
        <th>Deportista</th>
        <th>Prueba</th>
        <th>Fecha</th>
        <th>Resultado</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in data" :key="index">
        <td><strong>{{ item.Deportista }}</strong></td>
        <td>{{ item.Prueba }}</td>
        <td>{{ item.Fecha }}</td>
        <td class="tabla_info_calendario_txt">{{ item.Resultado }}</td>
      </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import axios from 'axios'
export default {
  data() {
    return {
      data: []
    }
  },
  methods: {
    async getDataCalendarResult() {
      try {
        const result = await axios.get('https://webmr.cl/api-jjoo/api/calendario')
        if (result.data) {
          this.data = result.data
        }
      } catch (error) { console.log(error) }
    }
  },
  mounted() {
    this.getDataCalendarResult()
  }
}
</script>